module.exports = __webpack_public_path__ + "static/media/44_A.2a738c5d.png";